export default {
	title: "Goal",
};
